import script from "./MailView.vue?vue&type=script&setup=true&lang=ts"
export * from "./MailView.vue?vue&type=script&setup=true&lang=ts"

import "./MailView.vue?vue&type=style&index=0&id=94b041b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94b041b2"]])

export default __exports__